<template>
  <svg
    :class="className"
    fill="none"
    :height="height"
    viewBox="0 0 40 40"
    :width="width"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect height="30" rx="2.66667" :stroke="fill" stroke-width="3" width="40"/>
    <rect :fill="fill" height="2" width="38" x="1" y="24"/>
    <path clip-rule="evenodd" d="M29.9968 40C29.6385 40 29.3075 39.8167 29.0959 39.5276C27.1021 36.8033 23.7976 35 20.0041 35C16.2105 35 12.9061 36.8033 10.9122 39.5276C10.7006 39.8167 10.3697 40 10.0114 40V40C9.21732 40 8.71609 39.1623 9.17496 38.5142C11.5318 35.1856 15.5027 33 20.0041 33C24.5055 33 28.4764 35.1856 30.8332 38.5142C31.2921 39.1623 30.7909 40 29.9968 40V40Z" :fill="fill" fill-rule="evenodd"/>
  </svg>


</template>

<script>
export default {
  name: 'Television',
  props: {
    width: {
      type: String,
      required: false,
      default: '100%'
    },
    height: {
      type: String,
      required: false,
      default: '100%'
    },
    className: {
      type: String,
      required: false,
      default: ''
    },
    fill: {
      type: String,
      required: false,
      default: '#000'
    },
  },
};

</script>
